// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"269a73cf","453":"1767a83d","455":"4ad62b9b","977":"9e880d5e"}[chunkId] + ".chunk.js";
};